import { Component, ReactNode } from 'react'

import ErrorAlert from '@/components/ErrorAlert/ErrorAlert'

type Props = {
  children: ReactNode
  tag?: string
}

type State = {
  error?: Error
  hasError: boolean
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error: Error) {
    return { error, hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: any) {
    const tag = this.props.tag ? `(${this.props.tag})` : ''
    console.warn(`ErrorBoundary${tag} caught:`, error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      const stack = this.state.error?.stack || this.state.error?.message
      return <ErrorAlert stack={stack} />
    }

    return this.props.children
  }
}

export default ErrorBoundary
